<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >
    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle}} Tipo de Requerimento
      </v-card-title>

      <v-card-text>

        <v-form
            ref="form"
            v-model="valid"
        >
          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="acronym"
                    :rules="requiredRules"
                    label="Sigla"
                    required
                />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12>
                <v-checkbox
                    v-model="requirePaymentAnalysis"
                    label="Há Estudo de Risco ou Análise de EIA/RIMA ou Análise de Projeto?"
                />
              </v-flex>
            </v-layout>

            <v-layout
                v-if="requirePaymentAnalysis">
              <v-flex xs12>

                <v-autocomplete
                    v-model="analysisTypeId"
                    :items="applicationTypes"
                    :rules="requiredRules"
                    label="Selecione um Tipo de Análise/Estudo"
                    no-data-text="Nenhum resultado encontrado"
                    :clearable="true"
                    item-text="name"
                    item-value="id"
                    :search-input.sync="search"
                    :loading="loadingSearch"
                    @click:clear="clearRequirePaymentAnalysis()"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-center>
          <v-btn
              :disabled="loading"
              flat
              @click="closeDialog()"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import ApplicationTypeService from '@/services/applications/configurations/ApplicationTypeService';
  import EnviromentalStudyTypeService from "@/services/applications/configurations/EnviromentalStudyTypeService";

  export default {
    name: 'CreateOrUpdate',
    props: ['item', 'mode', 'dialog'],
    components: {},
    data() {
      return {
        id: null,
        acronym: '',
        name: '',
        analysisTypeId: null,
        requirePaymentAnalysis: false,
        applicationTypes: [],
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        valid: false,
        interval: null,
        loadingSearch: false,
        loading: false,
        search: '',
      };
    },
    methods: {
      save() {
        this.loading = true;
        const payload = {
          id: this.id,
          acronym: this.acronym,
          name: this.name,
          analysis_type_id: (this.analysisTypeId || null),
        };
        EnviromentalStudyTypeService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Tipo de Documento ${ this.snackBarMode } com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.closeDialog();
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            })
          })
          .finally(() => {
            this.loading = false;
          });
      },
      clearRequirePaymentAnalysis() {
        this.requirePaymentAnalysis = false;
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
    computed: {
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      },
    },
    watch: {
      search() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          ApplicationTypeService
            .all({ q: (this.search || ''), page: 1 })
            .then((response) => {
              this.applicationTypes = response.data.application_types;
            })
            .finally(() => {
              this.loadingSearch = false;
              clearInterval(this.interval)
            });
        }, 500);
      },
      dialog(newValue) {
        if (newValue) {
          if (this.item !== null) {
            this.id = this.item.id;
            this.acronym = this.item.acronym;
            this.name = this.item.name;
            this.requirePaymentAnalysis = this.item.analysis_type_id !== null;
            this.analysisTypeId = this.item.analysis_type_id;
          }
        } else {
          this.$refs.form.reset();
        }
      },
      requirePaymentAnalysis(newValue){
        if (!newValue) this.analysisTypeId = null;
      }
    },
  };
</script>

<style scoped lang="scss">
</style>
